import React from 'react';
import { LabDirectoryView } from '../components/LabViews';
import { RouterAnchor } from './LabDetailPage';
import catalog from '../data/labs.json';
export default function LabsPage() { return <LabDirectoryView labs={catalog.labs} LinkComponent={RouterAnchor} />; }
